import React, { useEffect, useState } from 'react';
import LoadingCommon from '../LoadingCommon';
import { useSelector } from 'umi';
import { getGlobalResourceConfig } from '@op/services';

function useBeforeRequest({ ids }: { ids: Array<string> }) {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState({});

  const { userInfo, gameInfo, wholeGameInfo } = useSelector(
    ({ opinionCommon, home }: any) => {
      return {
        userInfo: home.userInfo,
        gameInfo: opinionCommon.gameInfo,
        wholeGameInfo: opinionCommon.wholeGameInfo,
        gameInfoLoading: opinionCommon.gameInfoLoading,
      };
    },
  );

  useEffect(() => {
    if (gameInfo?.edition_unified_id) {
      if (ids && ids.length > 0) {
        getGlobalResourceConfig({
          api_list: ids,
          edition_unified_id: gameInfo.edition_unified_id,
        })
          .then((data: any) => {
            setConfig(data || {});
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    }
  }, [gameInfo]);

  return { loading, config, userInfo, gameInfo, wholeGameInfo };
}

export default function BeforeRequest({
  ids,
  children,
}: {
  ids: Array<string>;
  children: (props: any) => JSX.Element;
}) {
  const { loading, ...props } = useBeforeRequest({ ids });
  return loading ? <LoadingCommon /> : children(props);
}
